// extracted by mini-css-extract-plugin
module.exports = {"boxDropdown":"_3TO_Mki1Y0Xg_qR-EEfEP9","dropdown":"_3txQKlIjp8dzsBQgqkKF7c","active":"_1BBF_K3nr2uyfEs4FXQdJC","selected":"_3B3qhQ-O0JBXBIF-ttHDhX"};